import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { BaseButton, useT } from '@repo/common';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';
import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

const SearchInFilterModal = ({
  initialSearchIn,
  appliedSearchIn,
  isOpen,
  setIsOpen,
  onChange,
}) => {
  const t = useT();
  const [searchIn, setSearchIn] = useState(initialSearchIn);
  const [dropdownCoords, setDropdownCoords] = useState(null);
  const sortButtonRef = useRef(null);

  const sortOptions = ['All', 'Questions', 'Answers'];
  const searchInLabelsKr = {
    All: '전체',
    Questions: '질문',
    Answers: '답변',
  };

  const handleSortButtonClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSearchIn(initialSearchIn);
  }, [initialSearchIn]);

  const getBorderClass = () => {
    if (searchIn !== appliedSearchIn) return 'border-grayscale-gray07';
    if (isOpen) return 'border-grayscale-gray07';
    return 'border-grayscale-gray03';
  };

  useEffect(() => {
    if (!isOpen) return;

    const updatePosition = () => {
      const rect = sortButtonRef.current.getBoundingClientRect();
      setDropdownCoords({
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
      });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen]);

  return (
    <>
      <button
        ref={sortButtonRef}
        onClick={handleSortButtonClick}
        className={`
            search-filter-button
            w-full h-12 px-4 flex justify-between items-center
            rounded-[8px] typo-16 border ${getBorderClass()}
          `}
      >
        {t(searchIn, searchInLabelsKr[searchIn] ?? searchIn)}
        {isOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
      </button>

      {/* 드롭다운 */}
      {isOpen &&
        dropdownCoords &&
        ReactDOM.createPortal(
          <ul
            className='filter-modal-container fixed z-[9999999] p-2 bg-white border border-grayscale-gray02
                         rounded-[8px] shadow-[0_0_6px_rgba(104,101,97,0.08)]'
            style={{
              top: dropdownCoords.top + 8,
              left: dropdownCoords.left,
              width: dropdownCoords.width,
            }}
          >
            {sortOptions.map((option) => (
              <li key={option} className='h-[38px] flex items-center'>
                <BaseButton
                  type='text'
                  width='100%'
                  bgclass='bg-grayscale-gray00 border-none h-full min-h-[38px] p-0'
                  textclass='justify-start h-full'
                  hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                  activeclass='active:bg-grayscale-gray01 active:text-text-primary'
                  icon={
                    <CheckIcon
                      className={`ml-2 ${
                        searchIn === option ? 'opacity-100' : 'opacity-0'
                      }`}
                    />
                  }
                  leftalign='true'
                  onClick={() => {
                    setSearchIn(option);
                    onChange(option);
                    setIsOpen(false);
                  }}
                >
                  {t(option, searchInLabelsKr[option] ?? option)}
                </BaseButton>
              </li>
            ))}
          </ul>,
          document.body
        )}
    </>
  );
};

export default SearchInFilterModal;
